import { takeLatest, put, all, call } from 'redux-saga/effects';

import CustomProductLoanActionTypes from './custom-product-loan-proposal.types';

import {
	addCustomProductLoanProposal,
	updateCustomProductLoanProposal,
	customProductDetailsFetch,
} from './custom-product-loan-proposal.service';

import {
	addCustomProductLoanProposalSuccess,
	addCustomProductLoanProposalFailure,
	addCustomProductLoanProposalListResponseChanged,
	updateCustomProductLoanProposalSuccess,
	updateCustomProductLoanProposalFailure,
	updateCustomProductLoanProposalListResponseChanged,
	fetchCustomProductDetailsSuccess,
	fetchCustomProductDetailsFailure,
	fetchCustomProductDetailsResponseChanged,
} from './custom-product-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START ADD CUSTOM PRODUCT LOAN PROPOSAL ******************** */
export function* createCustomProductLoanProposal({ payload }: any) {
	try {
		const key = 'addCustomProductLoanIndexKey';
		const jsonData = {
			AreaID: payload.branchID,
			BranchID: payload.centerID,
			LoanProposalDate: payload.loanProposalDate,
			TotalLoanAmount: payload.principalAmount,
			LoanStartDate: payload.loanStartDate,
			LoanEndDate: payload.loanEndDate,
			MeetUpLocation: payload.memberMeetUpLocation,
			MemberMeetupLat: payload.memberMeetUpLat,
			MemberMeetupLong: payload.memberMeetUpLong,
			MeetUpTime: payload.meetUpTime,
			GroupID: payload.groupID,
			GroupProductID: payload.productTypeID,
			GroupMemberLeadID: payload.memberLeadID,
			GroupOfficerID: payload.centerOfficerID,
			CompanyID: payload.companyID,
			CreatedUser: payload.userID,
			LoanIndexGroupMember: payload.selectedMemberArr,
			ProductInvestorDetails: '',
			LoanIndexType: 'Custom',
			FunderName: '',
			LoanType: payload.loanType,
			LoanOfficerID: payload.centerOfficerID,
			memberLeadID: payload.memberLeadID,
			DatabaseName: payload.databaseName,
			ProductAmount: payload.principalAmount,
			ProductPrincipal: payload.totalInterest,
			ProductInterest: payload.interestPercentage,
			ProductROI: payload.productROI,
			InstalmentType: payload.installmentType,
			NumberOfInstalment: payload.noOfInstalment,
			AmountOutsanding: payload.AmountOutsanding,
			InstallmentMethod: payload.InstallmentMethod,
			InstallmentReturnType: payload.InstallmentReturnType,
			NoOfYears: payload.NoOfYears,
			NoOfHolidays: payload.NoOfHolidays,
			LoanDataforDiminishing: payload.LoanDataforDiminishing,
			HolidayType: payload.HolidayType,
			MemberAmount: payload.MemberAmount,
			DocumentCharges: payload.DocumentCharges,
			ProcessingFees: payload.ProcessingFees,
			ProcessingFeesPercentage: payload.ProcessingFeesPercentage,
			IGST: payload.IGST,
			CGST: payload.CGST,
			SGST: payload.SGST,
			IsPenalty: payload.IsPenalty,
			PenaltyPercentage: payload.PenaltyPercentage,
			verificationFee: payload.verificationFee,
			HPFee: payload.HPFee,
			InsurenseFee: payload.InsurenseFee,
			InsurenseFeePercentage: payload.InsurenseFeePercentage,
			Noofstartday: payload.Noofstartday,
			IsAdjustInterestBasedOnDiffDays: payload.IsAdjustInterestBasedOnDiffDays ? '1' : '0',
			IsRoundOffToUpperValue: payload.IsRoundOffToUpperValue ? '1' : '0',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addCustomProductLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCustomProductLoanProposalFailure(responseData.data));
		} else {
			yield put(addCustomProductLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCustomProductLoanProposalFailure(error));
	}
}

export function* resetAddCustomProductLoanProposalResponse() {
	yield put(addCustomProductLoanProposalListResponseChanged());
}

export function* onCreateCustomProductLoanProposalDetails() {
	yield takeLatest(
		CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_START,
		createCustomProductLoanProposal,
	);
}

export function* onCreateCustomProductLoanProposalResponseReset() {
	yield takeLatest(
		CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddCustomProductLoanProposalResponse,
	);
}
/** *********************  END ADD CUSTOM PRODUCT LOAN PROPOSAL ******************** */

/** *********************  START ADD CUSTOM PRODUCT LOAN PROPOSAL ******************** */
export function* UpdateCustomProductLoanProposalDetails({ payload }: any) {
	try {
		const key = 'updateCustomLoanIndexKey';
		// console.log('payload', payload);

		const jsonData = {
			AreaID: payload.branchID,
			BranchID: payload.centerID,
			LoanProposalDate: payload.loanProposalDate,
			TotalLoanAmount: payload.principalAmount,
			LoanStartDate: payload.loanStartDate,
			LoanEndDate: payload.loanEndDate,
			MeetUpLocation: payload.memberMeetUpLocation,
			MemberMeetupLat: payload.memberMeetUpLat,
			MemberMeetupLong: payload.memberMeetUpLong,
			MeetUpTime: payload.meetUpTime,
			GroupID: payload.groupID,
			GroupProductID: payload.productTypeID,
			GroupMemberLeadID: payload.memberLeadID,
			GroupOfficerID: payload.centerOfficerID,
			CompanyID: payload.companyID,
			CreatedUser: payload.userID,
			LoanIndexGroupMember: payload.selectedMemberArr,
			ProductInvestorDetails: '',
			LoanIndexType: 'Custom',
			FunderName: '',
			LoanType: payload.loanType,
			LoanOfficerID: payload.centerOfficerID,
			memberLeadID: payload.memberLeadID,
			DatabaseName: payload.databaseName,
			ProductAmount: payload.principalAmount,
			ProductPrincipal: payload.totalInterest,
			ProductInterest: payload.interestPercentage,
			ProductROI: payload.productROI,
			InstalmentType: payload.installmentType,
			NumberOfInstalment: payload.noOfInstalment,
			AmountOutsanding: payload.AmountOutsanding,
			InstallmentMethod: payload.InstallmentMethod,
			InstallmentReturnType: payload.InstallmentReturnType,
			NoOfYears: payload.NoOfYears,
			NoOfHolidays: payload.NoOfHolidays,
			LoanDataforDiminishing: payload.LoanDataforDiminishing,
			HolidayType: payload.HolidayType,
			MemberAmount: payload.MemberAmount,
			DocumentCharges: payload.DocumentCharges,
			ProcessingFees: payload.ProcessingFees,
			ProcessingFeesPercentage: payload.ProcessingFeesPercentage,
			IGST: payload.IGST,
			CGST: payload.CGST,
			SGST: payload.SGST,
			IsPenalty: payload.IsPenalty,
			PenaltyPercentage: payload.PenaltyPercentage,
			verificationFee: payload.verificationFee,
			HPFee: payload.HPFee,
			InsurenseFee: payload.InsurenseFee,
			InsurenseFeePercentage: payload.InsurenseFeePercentage,
			Noofstartday: payload.Noofstartday,
			IsAdjustInterestBasedOnDiffDays: payload.IsAdjustInterestBasedOnDiffDays ? '1' : '0',
			IsRoundOffToUpperValue: payload.IsRoundOffToUpperValue ? '1' : '0',
			LoanIndexID: payload.LoanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateCustomProductLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCustomProductLoanProposalFailure(responseData.data));
		} else {
			yield put(updateCustomProductLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCustomProductLoanProposalFailure(error));
	}
}

export function* resetUpdateCustomProductLoanProposalResponse() {
	yield put(updateCustomProductLoanProposalListResponseChanged());
}

export function* onUpdateCustomProductLoanProposalDetails() {
	yield takeLatest(
		CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_START,
		UpdateCustomProductLoanProposalDetails,
	);
}

export function* onUpdateCustomProductLoanProposalResponseReset() {
	yield takeLatest(
		CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateCustomProductLoanProposalResponse,
	);
}
/** *********************  END ADD CUSTOM PRODUCT LOAN PROPOSAL ******************** */

/** *********************  START FETCH CUSTOM PRODUCT LOAN DETAILS ******************** */
export function* fetchCustomProductData({ payload }: any) {
	try {
		const key = 'getCustomLoanIndexInfoKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			Level: payload.userLevel,
			LoanIndexID: payload.LoanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(customProductDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCustomProductDetailsFailure(responseData.data));
		} else {
			yield put(fetchCustomProductDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCustomProductDetailsFailure(error));
	}
}

export function* resetFetchCustomProductDetailsResponse() {
	yield put(fetchCustomProductDetailsResponseChanged());
}

export function* onFetchCustomProductDetails() {
	yield takeLatest(
		CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_START,
		fetchCustomProductData,
	);
}

export function* onFetchCustomProductResponseReset() {
	yield takeLatest(
		CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_RESPONSE_RESET,
		resetFetchCustomProductDetailsResponse,
	);
}
/** *********************  END FETCH CUSTOM PRODUCT LOAN DETAILS ******************** */

export function* customproductLoanProposalSaga() {
	yield all([
		call(onCreateCustomProductLoanProposalDetails),
		call(onCreateCustomProductLoanProposalResponseReset),
		call(onUpdateCustomProductLoanProposalDetails),
		call(onUpdateCustomProductLoanProposalResponseReset),
		call(onFetchCustomProductDetails),
		call(onFetchCustomProductResponseReset),
	]);
}
